import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import faqImg from '@assets/img/qes_bj2.png'
import success_bj from '@assets/img/success_bj2.png'
import failed_bj from '@assets/img/failed_bj.png'
import { Checkbox, InputItem, TextareaItem, Toast, Picker } from 'antd-mobile'
import * as styles from './style/index.scss'
const CheckboxItem = Checkbox.CheckboxItem;
const AgreeItem = Checkbox.AgreeItem;
import { isValidPhone } from "@utils/index"
class Questionnaire extends ComponentExt<any, any> {
    private code: string
    constructor(props) {
        super(props)
        this.code = this.props.match.params.code
        this.state = {
            QESlist: [
                // {
                //     question: '01、您每天使用4G LTE的时长是多少？',
                //     answerList: [
                //         { value: 'A', content: '少于1小时' }, { value: 'B', content: '1-3小时' }, { value: 'C', content: '3-5小时' }, { value: 'D', content: '5-7小时' }, { value: 'E', content: '7小时以上' }
                //     ],
                //     qesType: '0',
                //     orderNum: '0',
                //     checked: [],
                //     answer: []
                // },
                // {
                //     question: '02、您使用4G LTE的主要活动是什么（最少选择2项）', answerList: [
                //         { value: 'A', content: '浏览社交媒体' }, { value: 'B', content: '看视频' }, { value: 'C', content: '游戏' }, { value: 'D', content: '浏览网页' }, { value: 'E', content: '会议' }, { value: 'F', content: '其他' }
                //     ], qesType: '1', orderNum: '1', checked: [], answer: []
                // },
                // {
                //     question: '03、您主要在何处使用4G LTE （多选题）', answerList: [
                //         { value: 'A', content: '家里' }, { value: 'B', content: '办公室' }, { value: 'C', content: '路上' }, { value: 'D', content: '户外或者室外' }]
                //     , qesType: '1', orderNum: '2', checked: [], answer: []
                // },
                // {
                //     question: '04、您目前网络数据服务主要来源哪里（多选题）', answerList: [
                //         { value: 'A', content: '公共wifi （如公司）' }, { value: 'B', content: '手机流量套餐' }, { value: 'C', content: '4G LTE' }, { value: 'D', content: '家庭wifi' }, { value: 'E', content: '其他' }]
                //     , qesType: '1', orderNum: '3', checked: [], answer: []
                // },
                // {
                //     question: '05、您如何评价您的4G LTE网络的稳定性', answerList: [
                //         { value: 'A', content: '非常差' }, { value: 'B', content: '非常好' }, { value: 'C', content: '一般' }
                //     ], qesType: '0', orderNum: '4', checked: [], answer: []
                // },
                // {
                //     question: '06、您在使用4G LTE时遇到过网络中断或者速度突然下跌的问题吗？', answerList: [
                //         { value: 'A', content: '从未' }, { value: 'B', content: '很少（每月一次或者更少）' }, { value: 'C', content: '偶尔' }, { value: 'D', content: '经常' }, { value: 'E', content: '总是' }
                //     ], qesType: '0', orderNum: '5', checked: [], answer: []
                // },
                // {
                //     question: '07、您如何评价当前4G LTE流量套餐的性价比', answerList: [
                //         { value: 'A', content: '非常差' }, { value: 'B', content: '一般' }, { value: 'C', content: '比较好' }, { value: 'D', content: '非常好' }
                //     ], qesType: '0', orderNum: '6', checked: [], answer: []
                // },
                // {
                //     question: '08、您每个月的移动数据流量使用情况大概在什么范围', answerList: [
                //         { value: 'A', content: '10G以下' }, { value: 'B', content: '10-30G' }, { value: 'C', content: '30-60G' }, { value: 'D', content: '60-120G' }, { value: 'E', content: '120G以上' }
                //     ], qesType: '0', orderNum: '7', checked: [], answer: []
                // },
                // {
                //     question: '09、如果您考虑从4G LTE转到其他流量服务提供商，可能的原因是什么', answerList: [
                //         { value: 'A', content: '产品有缺陷' }, { value: 'B', content: '速度太慢' }, { value: 'C', content: '网络信号不稳定' }, { value: 'D', content: '价格过高' }
                //         , { value: 'E', content: '不支持多设备链接' }, { value: 'F', content: '售后服务太差' }, { value: 'G', content: '其他' }
                //     ], qesType: '0', orderNum: '8', checked: [], answer: []
                // },
                // {
                //     question: '10、您的年龄段', answerList: [
                //         { value: 'A', content: '18岁以下' }, { value: 'B', content: '18-24岁' }, { value: 'C', content: '25-34岁' }, { value: 'D', content: '35-44岁' }, { value: 'E', content: '45-54岁' }, { value: 'F', content: '55以上' }
                //     ], qesType: '0', orderNum: '9', checked: [], answer: []
                // },
                // {
                //     question: '11、您目前从事的职业', answerList: [
                //         { value: 'A', content: '销售产品运营前端岗位' }, { value: 'B', content: '开发/质量/测试等研发岗位' }, { value: 'C', content: '采购/行政/人力/售后等后端支持岗位' }
                //         , { value: 'D', content: '创业者' }, { value: 'E', content: '学生/老师' }, { value: 'F', content: '服务业人员' }, { value: 'G', content: '自由职业' }, { value: 'H', content: '体制内工作者/非盈利机构人员' }
                //     ], qesType: '0', orderNum: '10', checked: [], answer: []
                // },
            ],
            hasError: false,
            phoneNumber: '',
            success: false,
            failed: false,
            title: '',
            successMsg: '',
            dsrDetail: {
                // "createDate": "2024-11-28 17:49:24",
                // "dsrCode": "DSR20241128174923952",
                // "dsrDesc": "321321",
                // "dsrId": "947913391644672000",
                // "dsrName": "321321321",
                // "dsrUrl": "https://aoacuatwap.lenovoconnect.com/#/dsr/DSR20241128174923952",
                // "endDate": "2024-12-11 17:48:40",
                // "pointNum": 99999,
                // "qesList": [
                //     {
                //         "answerFlag": 1,
                //         "createDate": "2024-11-28 17:49:24",
                //         "dsrId": "947913391644672000",
                //         "dsrQesId": "947913391669837824",
                //         "dsrQesName": "1111111111",
                //         "dsrQesType": "0",
                //         "optionList": [
                //             {
                //                 "createDate": "2024-11-28 17:49:24",
                //                 "descFlag": 0,
                //                 "dsrId": "947913391644672000",
                //                 "dsrQesId": "947913391669837824",
                //                 "dsrQesOptionId": "947913391669837825",
                //                 "optionName": "A",
                //                 "optionNameContent": "321321",
                //                 "orderNum": 1
                //             }
                //         ],
                //         "orderNum": 1
                //     }
                // ],
                // "startDate": "2024-11-13 17:48:40",
                // "successMsg": "321321"
            }
        }
    }

    async componentDidMount() {
        document.title = '调研问卷'
        try {
            this.$toast.loading('加载中，请稍后')
            const res = await this.api.getDsrDetail({ dsrCode: this.code })
            if (res && Object.keys(res).length != 0) {
                let QESlistNew = [];
                const qesList = JSON.parse(JSON.stringify(res.qesList))
                qesList.map((item, index) => {
                    let optionList = [];
                    let orderList = [];//排序数组
                    item.optionList.map((optionItem, optionIndex) => {
                        optionList.push({
                            value: optionItem.optionName,
                            content: optionItem.optionNameContent,
                            order: optionIndex + 1,
                            descFlag: optionItem.descFlag
                        })
                        if (item.dsrQesType == '4') {
                            orderList.push({
                                label: optionIndex + 1,
                                value: optionIndex + 1,
                            },)
                        }
                    })
                    QESlistNew.push({
                        question: (index + 1) <= 9 ? '0' + (index + 1) + '、' + item.dsrQesName : index + '、' + item.dsrQesName,
                        answerList: optionList,
                        qesType: item.dsrQesType,
                        orderNum: item.orderNum,
                        checked: [],
                        answer: [],
                        qesId: item.dsrQesId,
                        answerFlag: item.answerFlag,
                        orderList: orderList
                    })
                })

                this.setState({
                    dsrDetail: res,
                    title: res.dsrName,
                    QESlist: QESlistNew,
                    dsrId: res.dsrId,
                    successMsg: res.successMsg
                })
            } else {
                this.setState({
                    failed: true
                })
            }
            this.$toast.hide()
        } catch (error) {
        }
    }
    onChange = (val, content, orderNum) => {
        let QESlistNew = JSON.parse(JSON.stringify(this.state.QESlist))
        QESlistNew.map((item) => {
            if (item.qesType == '0' && item.orderNum == orderNum) {
                item.checked = [],
                    item.answer = [],
                    item.checked.push(val)
                item.answer.push(content)
            } else if (item.qesType == '1' && item.orderNum == orderNum) {
                if (item.checked.indexOf(val) == -1) {
                    item.checked.push(val)
                    item.answer.push(content)
                } else {
                    const index = item.checked.indexOf(val);
                    item.checked.splice(index, 1);
                    item.answer.splice(index, 1);
                }

            }
        })
        this.setState({
            QESlist: QESlistNew
        })
    }

    inputOnChange = (val, orderNum) => {
        let QESlistNew = JSON.parse(JSON.stringify(this.state.QESlist))
        QESlistNew.map((item) => {
            if (item.orderNum == orderNum) {
                item.checked = [] = item.checked,
                    item.answer = [],
                    item.answer[0] = val
            }
        })
        this.setState({
            QESlist: QESlistNew
        })
    }

    inputOnChangeBack = (val, orderNum, subItem) => {
        let QESlistNew = JSON.parse(JSON.stringify(this.state.QESlist))
        QESlistNew.map((item) => {
            if (item.orderNum == orderNum) {
                item.answer = [] = item.answer;
                item.answerList.map((item2) => {
                    if (item2.value == subItem.value) {
                        item.answer.map((item3, index3) => {
                            if (item3.includes(subItem.content)) {
                                if (item.answer[index3].includes(':')) {
                                    if (val) {
                                        item.answer[index3] = item.answer[index3].split(':')[0] + ":" + val;
                                    } else {
                                        item.answer[index3] = item.answer[index3].split(':')[0]
                                    }
                                } else {
                                    item.answer[index3] = item.answer[index3] + ":" + val;
                                }
                            }
                        })
                    }
                })
            }
        })
        this.setState({
            QESlist: QESlistNew
        })
    }

    onErrorClick = () => {
        if (this.state.hasError) {
            Toast.info('请输入正确的手机号');
        }
    }
    onChangePhone = (phoneNumber) => {
        if (phoneNumber.replace(/\s/g, '').length < 11) {
            this.setState({
                hasError: true,
            });
        } else {
            this.setState({
                hasError: false,
            });
        }
        this.setState({
            phoneNumber: phoneNumber.replace(/\s+/g, ''),
        });
    }
    onChangeOrder = (val) => {
        // console.log("onChangeOrderval", val)
    }
    onChooseOk = (val, orderNum, subItem) => {
        let QESlistNew = JSON.parse(JSON.stringify(this.state.QESlist))
        QESlistNew.map((item) => {
            if (item.orderNum == orderNum) {
                item.answerList.map((item) => {
                    if (item.order == val[0]) {
                        item.order = subItem.order;
                    }
                    if (item.value == subItem.value) {
                        item.order = val[0];
                    }
                })
            }
        })
        this.setState({
            QESlist: QESlistNew
        })
    }
    submit = async () => {
        if (!isValidPhone(this.state.phoneNumber)) {
            Toast.info('请输入正确的手机号')
        } else {
            let QESlistNew = JSON.parse(JSON.stringify(this.state.QESlist))
            let error = false;
            let errorArr = [];
            QESlistNew.map((item) => {
                if (item.answerFlag == '1' && ((item.qesType == '0' && item.checked.length == 0) ||
                    (item.qesType == '1' && item.checked.length < 2) ||
                    (item.qesType == '2' && ((item.answer.length == 0) || (item.answer.length == 1 && !item.answer[0]))) ||
                    (item.qesType == '3' && ((item.answer.length == 0) || (item.answer.length == 1 && !item.answer[0]))))) {
                    errorArr.push(
                        item.question.split('、')[0]
                    )
                    error = true
                    return
                }
            })
            if (error) {
                let errorString = errorArr.join()
                Toast.info(`第${errorString}题请按要求完成`)
            } else {
                let dtoList = []
                QESlistNew.map((item) => {
                    item.qes = item.question;
                    if (item.qesType == '0' || item.qesType == '1') {
                        item.qesOption = item.checked;
                    } else if (item.qesType == '4') {
                        let answerList = JSON.parse(JSON.stringify(item.answerList))
                        answerList.sort(function (a, b) {
                            return a.order - b.order;
                        });
                        let qesOptionNew = [];
                        let answerNew = [];
                        answerList.map((answerItem) => {
                            qesOptionNew.push(answerItem.value)
                            answerNew.push(answerItem.content)
                        })
                        item.qesOption = qesOptionNew;
                        item.answer = answerNew;
                    } else {
                        item.qesOption = []
                    }

                    delete item.answerList;
                    delete item.question;
                    delete item.checked;
                    delete item.orderList;
                    dtoList.push(item)
                })
                try {
                    this.$toast.loading('提交中，请稍后')
                    const res = await this.api.getAnswer({ loginName: this.state.phoneNumber })
                    if (res.length == 0) {
                        await this.api.answer({ loginName: this.state.phoneNumber, dsrId: this.state.dsrId, dtoList: dtoList })
                        this.$toast.hide()
                        Toast.info('提交成功,感谢您的参与！');
                        this.setState({
                            success: true
                        })
                    } else {
                        this.$toast.hide()
                        Toast.info('已参与完成调研!');
                    }

                } catch (error) {
                }
            }
        }

    }
    render(): React.ReactNode {
        return (
            <div className={styles.container}>
                {!this.state.success && !this.state.failed && (
                    <div className={styles.content}>
                        <img src={faqImg} className={styles.question_bj} />
                        <div className={styles.QESTitle}>{this.state.title}</div>
                        <div className={styles.QEScontent} >
                            {
                                this.state.QESlist.map((item, index) => (
                                    <div className={styles.QESItem} key={index}>
                                        <div className={styles.question}>
                                            {item.answerFlag == '1' ? <span style={{ color: '#f00' }}>*</span> : <></>}
                                            {item.question}
                                            {item.qesType == '0' ? <span style={{ color: '#EB6A1A', marginLeft: '5px' }}>[单选]</span> : <></>}
                                            {item.qesType == '1' ? <span style={{ color: '#EB6A1A', marginLeft: '5px' }}>[多选]</span> : <></>}
                                            {/* {item.qesType == '2' ? <span style={{ color: '#EB6A1A', marginLeft: '5px' }}>[简答]</span> : <></>}
                                            {item.qesType == '3' ? <span style={{ color: '#EB6A1A', marginLeft: '5px' }}>[简述]</span> : <></>} */}
                                            {item.qesType == '4' ? <span style={{ color: '#EB6A1A', marginLeft: '5px' }}>[请点击序号排序]</span> : <></>}
                                        </div>
                                        {
                                            item.qesType == '0' ?
                                                item.answerList.map((subItem, subIndex) => (
                                                    <>
                                                        <CheckboxItem key={subIndex} checked={subItem.value == item.checked[0]} onChange={() => this.onChange(subItem.value, subItem.content, item.orderNum)}>
                                                            <span className={styles.answerItem} key={subIndex}>{subItem.value}：{subItem.content}</span>
                                                        </CheckboxItem>
                                                        {subItem.value == item.checked[0] && subItem.descFlag == '1' && (
                                                            <div className={styles.inputBorder}> <InputItem maxLength={100} onChange={(value) => this.inputOnChangeBack(value, item.orderNum, subItem)}>
                                                            </InputItem></div>
                                                        )}
                                                    </>

                                                )) : item.qesType == '1' ?
                                                    item.answerList.map((subItem, subIndex) => (
                                                        <>
                                                            <CheckboxItem key={subIndex} onChange={() => this.onChange(subItem.value, subItem.content, item.orderNum)}>
                                                                <span className={styles.answerItem} key={subIndex}>{subItem.value}：{subItem.content}</span>
                                                            </CheckboxItem>
                                                            {item.checked.indexOf(subItem.value) !== -1 && subItem.descFlag == '1' && (
                                                                <div className={styles.inputBorder}> <InputItem maxLength={100} onChange={(value) => this.inputOnChangeBack(value, item.orderNum, subItem)}>
                                                                </InputItem></div>
                                                            )}
                                                        </>

                                                    )) : item.qesType == '2' ?
                                                        <div className={styles.inputBorder}> <InputItem maxLength={100} onChange={(value) => this.inputOnChange(value, item.orderNum)}>
                                                        </InputItem></div> : item.qesType == '3' ?
                                                            <div className={styles.inputBorder}><TextareaItem count={200} style={{ marginTop: 8 }} rows={5} onChange={(value) => this.inputOnChange(value, item.orderNum)}>
                                                            </TextareaItem></div>
                                                            : item.qesType == '4' ?
                                                                item.answerList.map((subItem, subIndex) => (
                                                                    <Picker
                                                                        data={item.orderList}
                                                                        // value={subItem.value}
                                                                        title="选择顺序"
                                                                        cols={1}
                                                                        onChange={this.onChangeOrder}
                                                                        okText="确定"
                                                                        dismissText="取消"
                                                                        onOk={(val) => this.onChooseOk(val, item.orderNum, subItem)}
                                                                    >
                                                                        <div className={styles.orderItem} key={subIndex}>
                                                                            <div>{subItem.value}：{subItem.content}</div>
                                                                            <div>序号：{subItem.order}</div>
                                                                        </div>
                                                                    </Picker>
                                                                ))
                                                                : <></>
                                        }
                                    </div>
                                ))
                            }
                            {this.state.QESlist.length != 0 && (
                                <>
                                    <div className={styles.QESItem}>
                                        <div className={styles.question}>请留下您的联系方式</div>
                                        <div className={styles.inputPhone}><InputItem
                                            type="phone"
                                            placeholder="请输入您的手机号（必填）"
                                            error={this.state.hasError}
                                            onErrorClick={this.onErrorClick}
                                            onChange={this.onChangePhone}
                                            value={this.state.phoneNumber}
                                        >手机号码：</InputItem></div>
                                    </div>
                                    <div className={styles.submitButton} onClick={this.submit}>
                                        提交问卷
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                )}
                {this.state.success && (
                    <div className={styles.success}>
                        <img src={success_bj} className={styles.success} />
                        <div className={styles.successMsg}>{this.state.successMsg}</div>
                    </div>

                )}
                {this.state.failed && (
                    <div className={styles.success}>
                        <img src={failed_bj} className={styles.success} />
                    </div>

                )}
            </div>
        )
    }
}

export default Questionnaire;
